import {computed, ComputedRef} from "vue";
import Translations from "@/models/Localization/Translations";
import {useStoreState} from "@/hooks/useStoreState";

/**
 * A composable function that provides reactive access to application translations
 * stored within the localization module of the state management store.
 *
 * @return {ComputedRef<Translations>} A reactive computed reference to the 'translations' object.
 */
export function useTranslations(): ComputedRef<Translations> {
  const store = useStoreState();

  const localizationState = computed(() => store.value.LocalizationModule);
  return computed(() => localizationState.value.translations);
}
